import * as React from "react";
import { Datagrid, ReferenceField, TextField, BooleanField, EditButton, DeleteWithConfirmButton } from "react-admin";
import { ExcelExport } from "../../../Helper/ExportExcel";
import CreatedByField from "../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { SourceCustomer } from "../../../Pages/Admin/Customer";
import { TitleHomebaseWarehouse } from "./Constant/Constant";
import HomebaseWarehouseDetail from "./HomebaseWarehouseDetail";
import { SourceVwUser } from "../../../Constants/Source";
import { CustomDateField } from "../../../Components/CustomDateField";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";
const HomebaseWarehouseList = props => {
  const ExportToExcel = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, "customerId", SourceCustomer).then(customer => {
      fetchRelatedRecords(records, "createdBy", SourceVwUser).then(createdBy => {
        const data = records.map(record => ({
          ...record,
          customer: customer[record.customerId]?.customerName,
          createdBy: `${createdBy[record.createdBy]?.registerId} - ${createdBy[record.createdBy]?.name}`,
        }));
        ExcelExport(
          [
            {
              header: "Location",
              key: "Location",
            },
            {
              header: "Customer",
              key: "CustomerId",
            },
            {
              header: "Created By",
              key: "CreatedBy",
            },
            {
              header: "Created Date",
              key: "CreatedDate",
            },
            {
              header: "IsActive",
              key: "IsActive",
            },
          ],
          data.map(v => [v.location, v.customer, v.createdBy, v.createdDate, v.isActive]),
          "Homebase Warehouse List"
        );
      });
    });
  };

  return (
    <PoolList {...props} bulkActionButtons={false} exporter={ExportToExcel} title={TitleHomebaseWarehouse.list}>
      <Datagrid expand={<HomebaseWarehouseDetail />}>
        <TextField source="location" />
        <ReferenceField label="Customer" source="customerId" reference={SourceCustomer} link={false}>
          <TextField source="customerName" />
        </ReferenceField>
        <CreatedByField source="createdBy" link={false} />
        <CustomDateField source="createdDate" showTime />
        {/* <CreatedByField source="updatedBy" link={false} />
                    <CustomDateField source="updatedDate" showTime /> */}
        <BooleanField source="isActive" />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </PoolList>
  );
};

export default HomebaseWarehouseList;
